import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { BaseApiService } from './base-api.service';
import { ApiModule } from './api.module';
import { CORE_CONFIGURATION } from '../../core/configuration';
import { Store } from '@ngxs/store';
import { SessionStateModel, SessionState } from '../session';
import { buildAwsApi } from '../util.class';
import { WindowService } from '../common';
import { BridgeService } from '../bridge';

@Injectable({
  providedIn: ApiModule,
  deps: [BaseApiService],
})
export class AuthApiService {
  keyMapAWS: any;
  keyMapActions: any;

  constructor(
    private http: BaseApiService,
    private store: Store,
    private win: WindowService,
    private bridge: BridgeService,
    @Inject(CORE_CONFIGURATION) private config
  ) {
    const { keyMapAWS, keyMapActions }: SessionStateModel = this.store.selectSnapshot(SessionState);
    this.keyMapAWS = keyMapAWS;
    this.keyMapActions = keyMapActions;
  }

  // TODO device api to dxl is broken at moment
  /* eslint-disable */
  device(params: any) {
    return of({
      installation_id: 'installationIdMock',
    });
    return this.http.post({
      apiBasePath: this.config.apiBasePath,
      path: `/v2/device`,
      body: params
    });
  }

  // anonymousLogin() {
  //   // if keyMapAWS is present, we should use it!
  //   const apiAWS = buildAwsApi(this.keyMapAWS,'session_start', {} );
  //   return this.http.get({
  //     path: apiAWS ?? '/JsLogin/v3/anonymousLogin',
  //     awsApi: apiAWS !== null
  //   });

  //   // return this.http.get({
  //   //   path: '/JsLogin/v3/anonymousLogin'
  //   // });
  // }

  // loggedLogin(username: string, password: string, sessionId: string): Observable<any> {
  //   // if keyMapAWS is present, we should use it!
  //   const apiAWS = buildAwsApi(this.keyMapAWS,'login', {} );
  //   return this.http.post({
  //     path: apiAWS ?? '/JsLogin/v3/loggedLogin',
  //     awsApi: apiAWS !== null,
  //     body: {
  //       username, password, session_id: sessionId, generate_psg_token: true,
  //       payload: {},
  //     },
  //   });
  //   // return this.http.post({
  //   //   path: '/JsLogin/v3/loggedLogin',
  //   //   body: {
  //   //     username, password, session_id: sessionId, generate_psg_token: true,
  //   //     payload: {},
  //   //   },
  //   // });
  // }

  profile() {
    // INVIARE IL TOKEN DELLA LOGGEDLOGIN NON DELL'ANONYMUS
    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(this.keyMapAWS,'profile_retrieve_profile', {} );
    return this.http.get({
      path: apiAWS ?? '/WebbusLogin/v1/profile',
      awsApi: apiAWS !== null
    });

    // return this.http.get({path: '/WebbusLogin/v1/profile'});
  }

  cookieAuth(value: Boolean) {
    const apiAWS = buildAwsApi(this.keyMapAWS ,'loginByCookie', { value } );
    return this.http.get({
      path: apiAWS,
      awsApi: apiAWS !== null
    });
    // loginIBM = this.win.decode(loginIBM);

    // this.bridge.openInBrowser(loginIBM);
  }

  boDetails(billingObject: string) {
    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(this.keyMapAWS,'boDetails', {billingObject} );
    return this.http.get({
      path: apiAWS ?? `/WebbusLogin/v1/boDetails?billingObject=${billingObject}`,
      awsApi: apiAWS !== null
    });
    // return this.http.get({path: `/WebbusLogin/v1/boDetails?billingObject=${billingObject}`});
  }

  /////////////////////////////
  ///////AWS-API//////
  ////////////////////////////
  
  /**
   * @deprecated
   */
  anonymousLoginAWS() {
    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(this.keyMapAWS,'session_start', {} );
    return this.http.get({
      path: apiAWS,
      awsApi: apiAWS !== null
    });
  }

  /**
   * @deprecated
   */
  loggedLoginAWS(username: string, password: string, sessionId: string): Observable<any> {
    // if keyMapAWS is present, we should use it!
    const apiAWS = buildAwsApi(this.keyMapAWS,'login', {} );
    return this.http.post({
      path: apiAWS,
      body: {
        username, password, session_id: sessionId, generate_psg_token: true,
        payload: {},
      },
      awsApi: apiAWS !== null
    });
  }


}
